import React, { FC, useEffect, useState } from 'react';
import { ReactComponent as EditIcon } from 'assets/icons/edit-blue.svg';
import {
  Input,
  InputWithSymbol,
  BaseModal,
  ToastMessage,
  formatPhoneNumber
} from '@cokitchen/cokitchen-components';
import EditManagerFooter from './edit-manager-footer';
import { toast } from 'react-toastify';
import { UserType } from 'models/user.model';
import { apiService } from 'utils/api';

type EditManagerProps = {
  show: boolean;
  onClose: () => void;
  manager: Partial<UserType>;
};

const baseUrl = process.env.REACT_APP_BRAND_MGT_API_URL;

const EditManagerModal: FC<EditManagerProps> = ({ show, onClose, manager }) => {
  const emptyForm = {
    first_name: manager?.first_name,
    last_name: manager?.last_name,
    email: manager?.email,
    phone_number: manager?.phone_number
  };
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(emptyForm);
  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const isDisabled = () => {
    return !formData.first_name || !formData.last_name || !formData.phone_number;
  };

  useEffect(() => {
    setFormData(emptyForm);
  }, [manager]);

  const sendDetails = async () => {
    setLoading(true);
    try {
      const id = manager?.id;
      const res = await apiService.post('admin/update-user', {
        data: {
          ...formData,
          phone_number: formatPhoneNumber(formData.phone_number ?? ''),
          user_id: id
        },
        baseUrl
      });
      if (res) toast(<ToastMessage message='Manager Updated Successfully' type='success' />);
      onClose();
    } catch (error: any) {
      toast(<ToastMessage message={error?.message} type='error' />);
    }
    setLoading(false);
  };

  return (
    <BaseModal
      position='right'
      isOpen={show}
      onRequestClose={onClose}
      title='Edit Manager Details'
      titleIcon={<EditIcon />}
      footer={
        <EditManagerFooter loading={loading} onConfirm={sendDetails} disabled={isDisabled()} />
      }>
      <form onSubmit={(ev) => ev.preventDefault()} className='space-y-4'>
        <div className='grid md:grid-cols-2 gap-6'>
          <Input
            name='first_name'
            label='First name'
            placeholder='First name'
            small
            onChange={handleChange}
            value={formData?.first_name}
          />
          <Input
            name='last_name'
            label='Last name'
            placeholder='Last name'
            small
            onChange={handleChange}
            value={formData?.last_name}
          />
        </div>
        <Input
          name='email'
          label='Email'
          placeholder='Company email'
          small
          onChange={handleChange}
          value={formData?.email}
          disabled
        />
        <InputWithSymbol
          type='phone'
          name='phone_number'
          label='Mobile no.'
          placeholder='+234 0124 422 333'
          small
          onChange={handleChange}
          value={formData?.phone_number || ''}
          symbol='flag'
        />
      </form>
    </BaseModal>
  );
};

export default EditManagerModal;
